// extracted by mini-css-extract-plugin
export default {"modalBodyContainer":"RemoveUserConfirmationModal__modalBodyContainer___NV9GX","footerContainer":"RemoveUserConfirmationModal__footerContainer___F85jY"};